export default "__VITE_ASSET__DPXPfVrS__"